﻿const courseRegister = {
  init: function () {
    const me = this;
    const container = document.querySelector('.courseRegister__container') ? document.querySelector('.courseRegister__container') : null;

    if (container) {
      me.bind(container);
    }

  },
  bind: function (container) {

    const step1 = document.querySelector('.courseRegister__step1');
    const step2 = document.querySelector('.courseRegister__step2');
    const step3 = document.querySelector('.courseRegister__step3');
    const nextStep = document.getElementById('nextStep');
    const radiomarks = document.getElementsByClassName('radiomark');
    const choice1 = document.querySelector('#choice1');
    const choice2 = document.querySelector('#choice2');

    Array.prototype.forEach.call(radiomarks, (radiolisten, index) => {

      radiolisten.addEventListener('click',
        (e) => {
          Array.prototype.forEach.call(radiomarks,
            (radio) => {
              nextStep.removeAttribute('disabled')
              radio.classList.remove('validation--error');
            });
        });

    });

    if (nextStep) {
      nextStep.addEventListener('click', (e) => {
        e.preventDefault()
        const log = step1.querySelector('p');

        if (choice1.checked) {
          step1.classList.add('is-hidden');
          step2.classList.remove('is-hidden');

          step2.classList.add('courseRegister__step2--single');

        } else if (choice2.checked) {
          step1.classList.add('is-hidden');
          step2.classList.remove('is-hidden');

          step2.classList.remove('courseRegister__step2--single');
        } else if (!choice1.checked && !choice2.checked) {
          Array.prototype.forEach.call(radiomarks, (radiomark, index) => {
            radiomark.classList.add('validation--error');
          });
        }
      });
    }
  }
}

courseRegister.initialize = () => {
  courseRegister.init();
};

module.exports = courseRegister;
